// ── i18n — язык интерфейса: русский, английский, испанский ────────────────────
// t("Текст") возвращает перевод на язык интерфейса; ключ — сама русская строка,
// поэтому без перевода показывается русский. Подстановки: t("Найдено: {0}", [n]).
// Язык: настройка «Язык интерфейса» (localStorage ac_ui_lang), по умолчанию — как
// в системе/браузере (русский, украинский, белорусский, казахский → русский;
// испанский → испанский; остальное → английский). Смена языка перезагружает
// страницу: все надписи, в том числе в константах модулей, берутся заново.

import en from './locales/en';
import es from './locales/es';

const KEY = 'ac_ui_lang';
const DICT = { en, es };

export const UI_LANG_OPTIONS = [
  ['auto', null],
  ['ru', 'Русский'],
  ['en', 'English'],
  ['es', 'Español'],
];

export function getUiLangSetting() {
  try { return localStorage.getItem(KEY) || 'auto'; } catch { return 'auto'; }
}

function systemLang() {
  const list = (typeof navigator !== 'undefined' && (navigator.languages?.length ? navigator.languages : [navigator.language])) || [];
  for (const l of list) {
    const c = String(l || '').toLowerCase().slice(0, 2);
    if (['ru', 'uk', 'be', 'kk'].includes(c)) return 'ru';
    if (c === 'es') return 'es';
    if (c === 'en') return 'en';
  }
  return 'en';
}

function resolve(setting) {
  return setting === 'ru' || setting === 'en' || setting === 'es' ? setting : systemLang();
}

export const LANG = resolve(getUiLangSetting());
export const SYSTEM_LANG = systemLang();

try { document.documentElement.lang = LANG; } catch {}

export function t(s, vars) {
  let r = LANG === 'ru' ? s : (DICT[LANG] && DICT[LANG][s]) || s;
  if (vars) r = r.replace(/\{(\w+)\}/g, (m, k) => (vars[k] !== undefined && vars[k] !== null ? String(vars[k]) : ''));
  return r;
}

// Для дат и чисел: 12 окт. / Oct 12 / 12 oct.
export const uiLocale = () => ({ ru: 'ru-RU', en: 'en-US', es: 'es-ES' }[LANG] || 'en-US');

export function setUiLang(v) {
  try { localStorage.setItem(KEY, v); } catch {}
  window.location.reload();
}
